export const QRTypes = {
  COMPS: "COMPS",
  comps: "comps",
  reduce: "reduce",
  REDUCE: "REDUCE",
  // FULL: "full",
};

export const WALKUP_PROMOTOR_EMAIL = "walkup@mytallyapp.com";

export const changeQRColor = (type, userEmail = "") => {
  let fgColor;
  switch (type) {
    case QRTypes.COMPS:
    case QRTypes.comps:
      fgColor = "#006400";
      break;
    case QRTypes.REDUCE:
    case QRTypes.reduce:
      // fgColor = userEmail === WALKUP_PROMOTOR_EMAIL ? "#2F58CD" : "#DC3535";
      fgColor = "#DC3535";
      break;
    // case QRTypes.FULL:
    //   fgColor = "#2F58CD";
    //   break;
    default:
      fgColor = "black";
      break;
  }
  return fgColor;
};
